<template>
  <div class="">
    <span @click="showModal = true" class="cursor-pointer hover:text-gray-400">
      {{ buttonText }}
    </span>

    <mail-modal v-if="showModal" @modal-close="showModal = false">
      <div
        class="flex-shrink-0 inline-block w-full px-4 py-6 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:p-6 md:w-152"
      >
        <div v-if="clickedFranchiseButton === false">
          <h2
            class="mb-2 text-2xl font-medium text-center text-blue-500"
            v-text="mailModalTitle"
          ></h2>
          <div class="md:space-x-5 md:flex">
            <div class="w-full md:w-1/2">
              <div
                class="block px-3 py-5 mb-5 bg-gray-400 border-blue-300 rounded cursor-pointer md:mb-0 md:shadow md:border hover:bg-blue-500 group"
                @click="clickedFranchiseButton = !clickedFranchiseButton"
              >
                <div>
                  <h4
                    class="text-lg font-semibold text-center text-blue-600 md:text-xl group-hover:text-white"
                    v-text="franchiseOptionTitle"
                  ></h4>
                </div>
              </div>
            </div>
            <div class="w-full md:w-1/2">
              <a
                class="block px-3 py-5 bg-gray-400 border-blue-300 rounded cursor-pointer md:shadow md:border hover:bg-blue-500 group"
                :href="`mailto:${buttonText}`"
              >
                <div>
                  <h4
                    class="text-lg font-semibold text-center text-blue-600 md:text-xl group-hover:text-white"
                    v-text="otherOptionTitle"
                  >
                    Anders
                  </h4>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3
                class="text-2xl font-medium text-center text-blue-600"
                v-text="chosenFranchiseOptionTitle"
              ></h3>
              <div class="mt-2">
                <p
                  class="text-sm text-center text-black"
                  v-text="chosenFranchiseOptionText"
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mail-modal>
  </div>
</template>

<script>
export default {
  name: 'MailModalButton',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    mailModalTitle: {
      type: String,
      required: true
    },
    franchiseOptionTitle: {
      type: String,
      required: true
    },
    otherOptionTitle: {
      type: String,
      required: true
    },
    chosenFranchiseOptionTitle: {
      type: String,
      required: true
    },
    chosenFranchiseOptionText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false,
      clickedFranchiseButton: false
    };
  },
  watch: {
    showModal: function() {
      document.body.style.overflow = this.showModal ? 'hidden' : '';
    }
  }
};
</script>
